import { useEffect } from "react";

// Configured production origin — canonical URLs always resolve to the apex domain.
const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://mahasampada.com").replace(/\/$/, "");

function upsertMeta(selector, attr, key, value) {
  let tag = document.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", value);
  return tag;
}

export function useSeo({ title, description, noindex = false }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) upsertMeta('meta[name="description"]', "name", "description", description);
    if (title) upsertMeta('meta[property="og:title"]', "property", "og:title", title);

    // robots: noindex for admin / draft-preview screens, index+follow for public pages
    upsertMeta('meta[name="robots"]', "name", "robots", noindex ? "noindex, nofollow" : "index, follow");

    // canonical: only for public (indexable) pages, always on the apex production domain
    let link = document.querySelector('link[rel="canonical"]');
    if (noindex) {
      if (link) link.remove();
    } else {
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      const path = window.location.pathname.replace(/\/+$/, "") || "";
      link.setAttribute("href", `${SITE_URL}${path}`);
    }
  }, [title, description, noindex]);
}
